import { NavItems } from 'root/layout/menu/nav-items/nav-items';

export { NavItems };
